import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename, columns) => {
    // data is an array of objects
    // columns is an array of objects: { header: 'Header Name', dataKey: 'key_in_data' }
    
    const exportData = data.map(row => {
        const rowData = {};
        columns.forEach(col => {
            rowData[col.header] = typeof col.dataKey === 'function' ? col.dataKey(row) : row[col.dataKey];
        });
        return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${filename}.xlsx`);
};

export const exportToPDF = (data, filename, columns, title) => {
    const doc = new jsPDF();
    
    const tableData = data.map(row => {
        return columns.map(col => {
            return typeof col.dataKey === 'function' ? col.dataKey(row) : row[col.dataKey];
        });
    });

    const tableHeaders = columns.map(col => col.header);

    doc.setFontSize(14);
    doc.text(title, 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString('en-IN')}`, 14, 22);

    autoTable(doc, {
        head: [tableHeaders],
        body: tableData,
        startY: 28,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [10, 25, 47] }, // #0A192F matches the theme
    });

    doc.save(`${filename}.pdf`);
};
